module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/th-b38fc7905f3099fbcc8b5ddc801c8c18.jpg";